<template>
  <div class="_ipbookingform global__scrollcustom">
    <form @submit.prevent="placeOrder()">
    <div class="_ipbookingform__wrapper">
      <InfoHeader
        class="_ipbookingform__wrapper--header"
        :header="bookingData"
        >
      </InfoHeader>
      <div class="_ipbookingform__wrapper--content">
        <div class="_content">
          <!-- <b-form @submit="onSubmit" @reset="onReset" v-if="show"> -->
            <h4>Shipper Details</h4>
            <div class="row mb-5">
              <div class="col-md">
                <b-form-group
                  id="input-group-1"
                  label="Shipper PIC Name "
                  label-for="input-1" >
                  <b-form-input
                    id="input-1"
                    v-model="data.form.shipper_name"
                    type="text"
                    placeholder="Insert Shipper PIC Full Name"
                    required
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  id="input-group-1"
                  label="Phone"
                  label-for="input-1" >
                  <b-form-input
                    id="input-1"
                    v-model="data.form.shipper_phone"
                    type="number"
                    required
                    placeholder="Shipper PIC Phone Number"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  id="input-group-1"
                  label="ZIP Code"
                  label-for="input-1" >
                  <b-form-input
                    id="input-1"
                    v-model="data.form.shipper_zip_code"
                    v-validate="'required'"
                    name="shipper_zipcode"
                    type="number"
                    required
                    placeholder="Shipper ZIP Code Number"
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-md">
                <b-form-group
                  id="input-group-1"
                  label="Company Name"
                  label-for="input-1" >
                  <b-form-input
                    id="input-1"
                    v-model="data.form.shipper_comp"
                    type="text"
                    required
                    placeholder="Shipper Company Name"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  id="input-group-1">
                  <div class="row m-0 justify-content-between align-items-end">
                     <label>Company Tax ID</label>
                     <small class="mb-2">*Optional</small>
                  </div>
                  <b-form-input
                    name="shipper_taxid"
                    type="text"
                    v-model="data.form.shipper_company_tax_id"
                    placeholder="Shipper Company Tax ID"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  id="input-group-1"
                  label="Company Address"
                  label-for="input-1" >
                  <b-form-textarea
                  id="textarea"
                  v-model="data.form.shipper_address"
                  placeholder="Shipper Company Address"
                  rows="3"
                  max-rows="6"
                ></b-form-textarea>
                </b-form-group>
              </div>
            </div>
            <!-- end Shipper Details -->
            <h4>Consignee Details</h4>
            <div class="row mb-4">
              <div class="col-md">
                <b-form-group
                  id="input-group-1"
                  label="Consignee PIC Name "
                  label-for="input-1" >
                  <b-form-input
                    id="input-1"
                    v-model="data.form.consignee_name"
                    type="text"
                    required
                    placeholder="Insert Consignee PIC Full Name"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  id="input-group-1"
                  label="Phone"
                  label-for="input-1" >
                  <b-form-input
                    id="input-1"
                    v-model="data.form.consignee_phone"
                    type="number"
                    required
                    placeholder="Consignee PIC Phone Number"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  id="input-group-1"
                  label="ZIP Code"
                  label-for="input-1">
                  <b-form-input
                    id="input-1"
                    v-validate="'required'"
                    name="consignee_zipcode"
                    type="number"
                    v-model="data.form.consignee_zip_code"
                    required
                    placeholder="Consignee ZIP Code Number"
                  ></b-form-input>
                </b-form-group>
                <b-form-checkbox
                  id="checkbox-1"
                  v-model="data.form.notifiy_party_same_consignee"
                  name="checkbox-1"
                  class="mt-4"
                  :value="1"
                  :unchecked-value="0"
                >
                  *Notify party is the same with consignee details
                </b-form-checkbox>
              </div>
              <div class="col-md">
                <b-form-group
                  id="input-group-1"
                  label="Company Name"
                  label-for="input-1" >
                  <b-form-input
                    id="input-1"
                    v-model="data.form.consignee_comp"
                    type="text"
                    required
                    placeholder="Consignee Company Name"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  id="input-group-1"
                  label-for="input-1" >
                  <div class="row m-0 justify-content-between align-items-end">
                    <label>Company Tax ID</label>
                    <small class="mb-2">*Optional</small>
                  </div>
                  <b-form-input
                    id="input-1"
                    name="consignee_taxid"
                    type="text"
                    v-model="data.form.consignee_company_tax_id"
                    placeholder="Consignee Company Tax ID"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  id="input-group-1"
                  label="Company Address"
                  label-for="input-1" >
                  <b-form-textarea
                  id="textarea"
                  required
                  v-model="data.form.consignee_address"
                  placeholder="Consignee Company Address"
                  rows="3"
                  max-rows="6"
                ></b-form-textarea>
                </b-form-group>
              </div>
            </div>
            <!-- Consignee Details -->
            <h4 v-if="data.form.notifiy_party_same_consignee === 0">Notify Party Details</h4>
            <div v-if="data.form.notifiy_party_same_consignee === 0" class="row mb-4">
              <div class="col-md">
                <b-form-group
                  id="input-group-1"
                  label="Notify Party PIC Name "
                  label-for="input-1" >
                  <b-form-input
                    id="input-1"
                    v-validate="'required'"
                    name="consignee_name"
                    type="text"
                    v-model="data.form.notifiy_party_name"
                    required
                    placeholder="Insert Notify Party PIC Full Name"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  id="input-group-1"
                  label="Phone"
                  label-for="input-1" >
                  <b-form-input
                    id="input-1"
                    v-validate="'required'"
                    name="consignee_phone"
                    type="number"
                    v-model="data.form.notifiy_party_phone"
                    required
                    placeholder="Notify Party PIC Phone Number"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  id="input-group-1"
                  label="ZIP Code"
                  label-for="input-1">
                  <b-form-input
                    id="input-1"
                    v-validate="'required'"
                    name="consignee_zipcode"
                    type="number"
                    v-model="data.form.notifiy_party_zip_code"
                    required
                    placeholder="Notify Party ZIP Code Number"
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-md">
                <b-form-group
                  id="input-group-1"
                  label="Company Name"
                  label-for="input-1" >
                  <b-form-input
                    id="input-1"
                    v-validate="'required'"
                    name="consignee_comp"
                    type="text"
                    v-model="data.form.notifiy_party_comp"
                    required
                    placeholder="Notify Party Company Name"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  id="input-group-1"
                  label-for="input-1" >
                  <div class="row m-0 justify-content-between align-items-end">
                     <label>Company Tax ID</label>
                     <small class="mb-2">*Optional</small>
                  </div>
                  <b-form-input
                    id="input-1"
                    name="consignee_taxid"
                    type="text"
                    v-model="data.form.notifiy_party_company_tax_id"
                    placeholder="Notify Party Company Tax ID"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  id="input-group-1"
                  label="Company Address"
                  label-for="input-1" >
                  <b-form-textarea
                  id="textarea"
                  name="consignee_address"
                  v-model="data.form.notifiy_party_address"
                  v-validate="'required'"
                  placeholder="Notify Party Company Address"
                  required
                  rows="3"
                  max-rows="6"
                ></b-form-textarea>
                </b-form-group>
              </div>
            </div>

            <h4>Shipper Notes</h4>
            <div class="col-md p-0">
              <b-form-group
                id="input-group-1"
                label-for="input-1"
                description="*Optional">
                  <b-form-textarea
                    id="textarea"
                    v-model="data.form.shipper_notes"
                    placeholder="e.g : 'cargo can't be stacked, cargo load into lower deck.'"
                    rows="4"
                    max-rows="6">
                  </b-form-textarea>
              </b-form-group>
            </div>
          <!-- </b-form> -->
        </div>
      </div>
    </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import InfoHeader from '@/components/instantPrice/InfoHeader'
export default {
  name: 'ipbookingform',
  components: {
    InfoHeader
  },
  data () {
    return {
      data: {
        form: {
          shipper_name: '',
          shipper_comp: '',
          shipper_address: '',
          shipper_phone: '',
          shipper_email: '',
          shipper_zip_code: '',
          shipper_company_tax_id: '',
          consignee_name: '',
          consignee_comp: '',
          consignee_address: '',
          consignee_phone: '',
          consignee_email: '',
          consignee_zip_code: '',
          consignee_company_tax_id: '',
          shipper_notes: '',
          notifiy_party_comp: '',
          notifiy_party_name: '',
          notifiy_party_address: '',
          notifiy_party_phone: '',
          notifiy_party_zip_code: '',
          notifiy_party_company_tax_id: '',
          notifiy_party_same_consignee: 1,
          // insert from payload here
          book_price_currency_code: 'IDR',
          commodities_class: '',
          commodities_type: '',
          goodsValue: '',
          commodities_hscode: '',
          commodities_product: '',
          incoterms: 'FOB',
          book_type: 'export',
          // reference_number: 'CTC/2019040200000001',
          shipment: '',
          status_shipment: 0,
          delivery_address: '',
          pickup_address: '',
          temperature: 0
        },
        quote: {},
        query: {}
      },
      show: true,
      payloadLog: {
        featureName: 'CREATE INSTANT PRICE',
        featureStep: 7,
        stepName: 'Booking Instant Price',
        featureProcess: {
          status: 'success',
          data: {}
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      bookingData: 'instantprice/item'
    }),
    ...mapGetters({
      auth: 'auth/profile',
      authError: 'auth/error',
      authIsLoading: 'auth/isLoading'
    })
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      let auth = this.auth
      let temp = this.data.form
      // cek auth
      if (auth) {
        // import
        if (this.bookingData.destination_country === 'IDN' || auth.companyHeadQuarter === this.bookingData.destination_country) {
          temp.consignee_name = auth.customerName
          temp.consignee_comp = auth.companyName
          temp.consignee_address = auth.companyAddress
          temp.consignee_phone = auth.customerPhone
          temp.book_type = 'import'
        } else {
          temp.shipper_name = auth.customerName
          temp.shipper_comp = auth.companyName
          temp.shipper_address = auth.companyAddress
          temp.shipper_phone = auth.customerPhone
          temp.book_type = 'export'
        }
      }
      // cek if book data visible
      if (this.bookingData) {
        // assign data from payload
        this.data.query = this.bookingData.inputData
        this.data.quote = this.bookingData.bookData
        //

        if (this.data.query.shipmentLoad === 'aircargo') {
          // this.data.query.form.loadsAIRCargo[0].weight = parseInt(this.data.query.form.loadsAIRCargo[0].weight) * parseInt(this.data.query.form.loadsAIRCargo[0].qty)
          this.data.query.form.loadsAIRCargo[0].weight = this.data.query.form.totalWeight
          this.data.query.form.loadsAIRCargo[0].volume = parseInt(this.data.query.form.totalVolumetric)
        } else if (this.data.query.shipmentLoad === 'aircourier') {
          // this.data.query.form.loadsAIRCourier[0].weight = parseInt(this.data.query.form.loadsAIRCourier[0].weight) * parseInt(this.data.query.form.loadsAIRCourier[0].qty)
          this.data.query.form.loadsAIRCourier[0].weight = this.data.query.form.totalWeight
          this.data.query.form.loadsAIRCourier[0].volume = parseInt(this.data.query.form.totalVolumetric)
        } else if (this.data.query.shipmentLoad === 'lcl') {
          // this.data.query.form.loadsLCL[0].weight = parseInt(this.data.query.form.loadsLCL[0].weight) * parseInt(this.data.query.form.loadsLCL[0].qty)
          this.data.query.form.loadsLCL[0].weight = this.data.query.form.totalWeight
        }

        this.data.form.commodities_class = this.bookingData.inputData.form.commoditiesClass
        this.data.form.commodities_type = this.bookingData.inputData.form.productType
        this.data.form.goodsValue = this.bookingData.inputData.form.goodsValue
        this.data.form.commodities_hscode = this.bookingData.inputData.form.commoditiesHSCode
        this.data.form.po_number = this.bookingData.inputData.form.po_number
        this.data.form.pickup_address = this.bookingData.inputData.form.pickup_address
        this.data.form.delivery_address = this.bookingData.inputData.form.delivery_address
        this.data.form.commodities_product = this.bookingData.inputData.form.commoditiesProduct
        this.data.form.satuan = this.data.query.shipmentLoad === 'aircargo' ? this.bookingData.inputData.form.loadsAIRCargo[0].type
          : this.data.query.shipmentLoad === 'aircourier' ? this.bookingData.inputData.form.loadsAIRCourier[0].type
            : this.data.query.shipmentLoad === 'lcl' ? this.bookingData.inputData.form.loadsLCL[0].type : 'container'
        // this.data.form.temperature = this.bookingData.inputData.form.temperature
        //
        this.data.quote.carrier_name = this.bookingData.bookData.orderShippingLine
        this.data.quote.destination_city = this.bookingData.bookData.orderDestinationCity
        this.data.quote.destination_city_code = this.bookingData.bookData.orderDestinationCityCode
        this.data.quote.destination_country = this.bookingData.bookData.orderDestinationCountry
        this.data.quote.destination_country = this.bookingData.bookData.orderDestinationCountry
        this.data.quote.destination_country_code = this.bookingData.bookData.orderDestinationCountryCode
        this.data.quote.freight_direct = this.bookingData.bookData.orderDirect
        this.data.quote.freight_mode = this.bookingData.bookData.orderFreight
        this.data.quote.origin_city = this.bookingData.bookData.orderOriginCity
        this.data.quote.origin_city_code = this.bookingData.bookData.orderOriginCityCode
        this.data.quote.origin_country = this.bookingData.bookData.orderOriginCountry
        this.data.quote.origin_country_code = this.bookingData.bookData.orderOriginCountryCode
        this.data.quote.price_currency_code = this.bookingData.bookData.orderPriceCurrencyCode
        this.data.quote.valid_until = this.bookingData.bookData.orderValidUntil
        this.data.quote.price_total = this.bookingData.bookData.orderPriceTotal
        this.data.quote.transittime_min = this.bookingData.bookData.orderTransittimeMin
        this.data.quote.transittime_max = this.bookingData.bookData.orderTransittimeMax
        this.data.quote.vendor_id = this.bookingData.bookData.vendorId
        this.data.quote.vendor_name = this.bookingData.bookData.vendorName
        this.data.quote.rfqStatus = false
        this.data.quote.freight_type = this.bookingData.inputData.form.shipment_type
        this.data.quote.freight_sub_type = this.bookingData.inputData.form.freight_sub_type
        this.data.quote.optiontp = this.bookingData.inputData.form.optiontp
        this.data.quote.container_option = this.bookingData.inputData.form.container_option
        this.data.quote.un_number = this.bookingData.inputData.form.un_number
        this.data.quote.weight_estimation = this.bookingData.inputData.form.weight_estimation ? parseFloat(this.bookingData.inputData.form.weight_estimation, 10) : 0
      }

      // insert log
      this.payloadLog.featureProcess.data = this.data
      this.$store.dispatch('log/CREATE_LOG', this.payloadLog)
    },
    placeOrder: function () {
      this.$eventHub.$emit('dialog-instantprice-form', this.data)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/IPbookingForm/index.vue